import { render, staticRenderFns } from "./ProjectLocation.vue?vue&type=template&id=8fe8a0b8&scoped=true&"
var script = {}
import style0 from "./ProjectLocation.vue?vue&type=style&index=0&id=8fe8a0b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe8a0b8",
  null
  
)

export default component.exports